export default __webpack_public_path__ + "static/media/circle1-en.3b81ed38.svg";